import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.47 3.47a.75.75 0 0 0 0 1.06L16.94 12l-7.47 7.47a.75.75 0 1 0 1.06 1.06l8-8a.75.75 0 0 0 0-1.06l-8-8a.75.75 0 0 0-1.06 0"/>' }
  })
);